import { NavLink } from 'react-router-dom';
import { useRouter } from "../../hooks/router";
import { useEffect, useState } from "react";
import { translateWord } from "../Util/util";
import { forgot_password } from "../../server/requests";
import ErrorMessage from '../AlertMessage/ErrorMessage';

export default function ForgotPassword({
    setPopUpTitles
}) {

    const router = useRouter()

    const [validate, setValidate] = useState(false)
    const [valueForgotPassword, setValueForgotPassword] = useState('')
    const [errorMessage, setErrorMessage] = useState({
        show: false,
        text: '',
        type: ''
    })

    useEffect(() => {
        setPopUpTitles('Forgot Password')
    }, [])

    const onChange = (e) => {
        const { value } = e.target;
        setValueForgotPassword(value)
        if (validate) setValidate(false)
    }

    const onSubmit = (e) => {
        e.preventDefault();

        const re = /\S+@\S+\.\S+/;
        const valid = re.test(valueForgotPassword);

        if (valid) {
            forgot_password({ email: valueForgotPassword }, res => {
                let _url = ''

                if (router.query.from) _url = '/auth/reset-password?from=' + router.query.from

                else _url = '/auth/verify-code'

                router.push(_url)
            }, err => {
                show_hide_message(translateWord(err), 'error')
                setValidate(true)
            })
        } else {
            show_hide_message(translateWord('Please enter a valid email address'), 'error')
            setValidate(true)
        }
    }

    const show_hide_message = (text, type) => {
        setErrorMessage({
            show: true,
            text: text,
            type: type
        })
        setTimeout(() => {
            setErrorMessage({
                show: false,
                text: '',
                type: ''
            })
        }, 3000);
    }

    return (
        <>
            <ErrorMessage text={errorMessage.text} type={errorMessage.type} show={errorMessage.show} />
            <div className="login">
                <form onSubmit={onSubmit}>
                    <label htmlFor="">{translateWord('email', 'E-Mail')}:</label>
                    <input className={validate ? 'not_valid' : ''} type="text" value={valueForgotPassword}
                        name={'email'} onChange={onChange} placeholder={translateWord('Email')} />
                    <button type={'submit'} className={'card_color forgot'}>{translateWord('Send', 'Send')}</button>

                    <p>
                        {translateWord('Already have an account?', 'Already have an account?')} {' '}
                        <NavLink to={'/auth'}>{translateWord('Sign In', 'Sign In')} </NavLink>
                    </p>
                </form>
            </div>
        </>
    )
}
